import { render } from "./AiUsageAgents.vue?vue&type=template&id=4e12e182&scoped=true"
import script from "./AiUsageAgents.vue?vue&type=script&lang=js"
export * from "./AiUsageAgents.vue?vue&type=script&lang=js"

import "./AiUsageAgents.vue?vue&type=style&index=0&id=4e12e182&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e12e182"]])

export default __exports__